<app-page-title pageTitle="EAUTHORISATION-OVERVIEW.ACCESSIBILITY-STATMENT.TITLE"></app-page-title>

<div class="assign-overview-container section-p">
    <div class="main-box-style">
        <div class="steps-container">
                <div id="AccessibilityStatement">

                        <p>
                        Središnji državni ured za razvoj digitalnog društva nastoji svoje
                        mrežne stranice učiniti pristupačnima u skladu
                        <a
                            class="secundary-link"
                            href="http://sredisnjikatalogrh.gov.hr/cadial/searchdoc.php?action=search&lang=hr&query=pristupa%C4%8Dnost&searchText=on&searchTitle=on&resultdetails=basic&bid=%2bELrvTWXEzq35H83vcz6kg%3d%3d&annotate=on"
                        >
                            Zakonom o pristupačnosti mrežnih stranica i programskih rješenja za
                            pokretne uređaje tijela javnog sektora Republike Hrvatske
                        </a>
                        (&bdquo;Narodne novine&ldquo;, broj 17/19; dalje u tekstu: Zakon)
                        kojim se prenosi:
                        <a
                            class="secundary-link"
                            href="https://eur-lex.europa.eu/legal-content/HR/AUTO/?uri=OJ:L:2016:327:TOC"
                        >
                            Direktiva (EU) 2016/2102 Europskog parlamenta i Vijeća od 26.
                            listopada 2016. o pristupačnosti internetskih stranica i mobilnih
                            aplikacija tijela javnog sektora
                        </a>
                        (SL L 327, 2.12.2016.).
                        <br />
                        Ova Izjava o pristupačnosti primjenjuje se na mrežno sjedište
                        <a href="https://e-ovlastenja.gov.hr/">
                            https://e-ovlastenja.gov.hr/
                        </a>
                        </p>

                        <h2>Stupanj usklađenosti</h2>
                        <p>
                        Mrežno sjedište
                        <a href="https://e-ovlastenja.gov.hr/">
                            https://e-ovlastenja.gov.hr/
                        </a>
                        djelomično je usklađeno sa Zakonom zbog neusklađenosti koje su
                        navedene u nastavku.
                        </p>

                        <h2>Nepristupačan sadržaj</h2>
                        <p>Sadržaj naveden u nastavku je nepristupačan iz razloga:</p>

                        <ul>
                        <li>
                            Nisu dosljedno korišteni HTML elementi za isticanje naslova u tekstu
                            (h1, h2, h3 i sl.) i za odlomke u tekstu (p)
                        </li>
                        <li>
                            Za naglašavanje teksta djelomično se koriste &lt;strong&gt; i
                            &lt;em&gt; elementi
                        </li>
                        <li>Kontrasti pojedinih elemenata nisu zadovoljavajući</li>
                        <li>
                            Pojedine slike, grafovi i dijagrami nemaju prikladan opis
                            (&lt;alt&gt; atribute)
                        </li>
                        <li>Sadržaj pojedinih poveznica nije dovoljno dobro opisan</li>
                        <li>
                            Dio poveznica nije označen podcrtavanjem ili na drugi dovoljno jasan
                            način
                        </li>
                        <li>
                            Nije osiguran alternativni zvučni opis informacije za nepristupačan
                            sadržaj
                        </li>
                        <li>Veličina ikona nije zadovoljavajuća</li>
                        </ul>

                        <p>
                        Središnji državni ured za razvoj digitalnog društva radi na uklanjanju
                        uočenih neusklađenosti.
                        </p>

                        <h2>Priprema ove izjave o pristupačnosti</h2>
                        <p>
                        Ova je izjava sastavljena 21. rujna 2020. godine, prema Predlošku
                        izjave o pristupačnosti koji je u skladu s Direktivom (EU) 2016/2102
                        Europskog parlamenta i Vijeća o pristupačnosti internetskih stranica i
                        mobilnih aplikacija tijela javnog sektora, a utvrđen je
                        <a
                            class="secundary-link"
                            href="https://eur-lex.europa.eu/legal-content/HR/TXT/HTML/?uri=CELEX:32018D1523&qid=1590482508144&from=HR"
                        >
                            Provedbenom odlukom Komisije (EU) 2018/1523
                        </a>
                        <br />
                        Procjena usklađenosti sa zahtjevima pristupačnosti rezultat je
                        samoprocjene Središnjeg državnog ureda za razvoj digitalnog društva.
                        </p>

                        <p>
                        Središnji državni ured za razvoj digitalnog društva će redovito
                        revidirati ovu izjavu po otklanjanju razloga zbog kojih su pojedini
                        sadržaji bili nepristupačni.
                        </p>

                        <h2>Povratne informacije i podaci za kontakt</h2>
                        <p>
                        Molimo korisnike ovih mrežnih stranica ako primijete neusklađen
                        sadržaj, koji nije obuhvaćen ovom izjavom, da o tome obavijeste
                        Središnji državni ured za razvoj digitalnog društva.
                        <br />
                        Sve upite vezane uz pristupačnost mrežnog sjedišta
                        <a href="https://e-ovlastenja.gov.hr/">
                            https://e-ovlastenja.gov.hr/
                        </a>
                        korisnici mogu uputiti putem elektroničke pošte:
                        <a href="mailto:pristupacnost@rdd.hr"> pristupacnost&#64;rdd.hr </a>
                        </p>

                        <h2>Postupak praćenja provedbe propisa</h2>
                        <p>
                        Povjerenik za informiranje Republike Hrvatske je tijelo nadležno za
                        praćenje usklađenosti mrežnih stranica i programskih rješenja za
                        pokretne uređaje tijela javnog sektora sa zahtjevima pristupačnosti
                        kao i za nadzor nad provedbom Zakona.
                        <br />
                        U slučaju nezadovoljavajućih odgovora na obavijest ili zahtjev za
                        povratne informacije o pristupačnosti ovih mrežnih stranica, korisnici
                        se mogu obratiti Povjereniku za informiranje putem elektroničke pošte:
                        <a class="secundary-link" href="mailto:pristupacnost@pristupinfo.hr" >
                            pristupacnost&#64;pristupinfo.hr
                        </a>
                        </p>
                </div>
            </div>
    </div>
</div>